import {
    includeRule,
    excludeRule
  }
  from './rules_functions.js';
  
export function rules_sh(newState, state) {
  let slist = state['options_sh'].options.flatMap(x => x['value'])
  var newrule = includeRule(newState, state, 'sh')

    newrule = excludeRule(newState, state, [
        ['type', ['R']],
        ['sh', slist.filter(x => x.substring(0,1) !== 'R')]], newrule)

    newrule = excludeRule(newState, state, [
        ['type', ['P']],
        ['sh', slist.filter(x => x.substring(0,1) !== 'P')]], newrule)

    newrule = excludeRule(newState, state, [
        ['type', ['E']],
        ['sh', slist.filter(x => x.substring(0,1) !== 'E')]], newrule)

    newrule = excludeRule(newState, state, [
        ['type', ['B']],
        ['sh', slist.filter(x => x.substring(0,1) !== 'B')]], newrule)

    newrule = excludeRule(newState, state, [
        ['ds', ['HECU']],
        ['sh', ['P8']]], newrule)

    newrule = excludeRule(newState, state, [
        ['ds', ['HPS']],
        ['sh', ['B4']]], newrule)

    newrule = excludeRule(newState, state, [
        ['sh', ['R8', 'P4', 'E4']]], newrule)

    return newrule
}



// WEBPACK FOOTER //
// ./src/reducers/rules_sh.js